// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__8o_Gx","button__icon":"Button_button__icon__EQ1Zi","buttonFullWidth":"Button_buttonFullWidth__jv1KW","lenkestyling":"Button_lenkestyling__A5XEQ"};